<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Approve Fee Concession List">
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-col cols="12" md="4" lg="4">
          <v-text-field @input="searchData()" v-model="search" label="Search"></v-text-field>
        </v-col>
        <v-col class="pb-0" cols="12" md="4" lg="4">
          <v-autocomplete
            @change="
              page = page > 1 ? page - 1 : page
              getConcessionList()
            "
            label="Classes"
            class="my-0 py-1"
            :items="classList"
            item-text="name"
            item-value="id"
            placeholder="--All--"
            name="classSelect"
            v-model="selectedClass"
          >
          </v-autocomplete>
        </v-col>
        <v-col class="pb-0" cols="12" md="4" lg="4">
          <v-autocomplete
            @change="
              page = page > 1 ? page - 1 : page
              getConcessionList()
            "
            label="Status"
            class="my-0 py-1"
            :items="typeOptions"
            item-text="text"
            item-value="value"
            placeholder="--All--"
            name="classSelect"
            v-model="selectedType"
          >
          </v-autocomplete>
        </v-col>
      </v-card-text>
      <v-divider class="my-0" />
      <v-data-table disable-pagination :hide-default-footer="true" :headers="headers" :items="tblData">
        <template v-slot:item.actions="{ item }">
          <v-btn v-if="item.status === 'PENDING'" @click="viewRequest(item)" class="px-2 ml-1 white--text ma-1" color="success" min-width="0" small>
            <v-icon small> mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="10" @input="handlePageChange"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </material-card>

    <loading-icon :value="isLoading" />
    <!--Review Modal Start-->
    <v-dialog
      persistent
      v-model="reviewModal"
      :active="reviewModal"
      width="500"
      :on-cancel="
        () => {
          reviewModal = false
        }
      "
      transition="dialog-bottom-transition"
    >
      <form>
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title
              >Concession Request
              <v-btn @click="reviewModal = false" icon dark absolute right type="button"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field readonly color="accent" label="Installment Name" v-model.trim="concessionRequest.name" pattern="[a-zA-Z\s]+"> </v-text-field>
            <v-text-field color="accent" label="Concession Remark" v-model.trim="concessionRequest.concessionRemark"> </v-text-field>
            <v-text-field class="number-input" color="accent" type="number" label="Concession Amount" v-model.trim="concessionRequest.concessionAmount"> </v-text-field>
            <p class="text-note">NOTE: You can either approve or edit the concession amount before approving.</p>
            <!-- <label>Due Date</label>
            <custom-date-picker label="Due Date" v-model="concessionRequest.dueDate" /> -->
          </v-card-text>
          <v-card-text> </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="approveRequest('REJECTED')" color="error" type="button">Reject</v-btn>
            <v-btn @click="approveRequest('APPROVED')" color="success" type="button">Approve</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
    <!--Review Modal End-->
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import CustomDatePicker from '@/components/template/CustomDatePicker'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'ApproveConcessionList',
  components: { MaterialCard },
  data () {
    return {
      concessionRequest: {
        id: '',
        name: '',
        concessionRemark: '',
        concessionAmount: '',
        dueDate: ''
      },
      typeOptions: [
        { text: 'All', value: '' },
        { text: 'Approved', value: 'APPROVED' },
        { text: 'Pending', value: 'PENDING' },
        { text: 'Rejected', value: 'REJECTED' }
      ],
      selectedType: '',
      isLoading: false,
      deleted: false,
      reviewModal: false,
      search: '',
      tblData: [],
      classList: [],
      selectedClass: '',
      academicYearID: '',
      franchiseeID: '',
      total: 0,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      headers: [
        { text: 'Name', sortable: true, value: 'assignFeeInstallment.enquiry.studentFirstName' },
        { text: 'Enrollment Code', sortable: true, value: 'assignFeeInstallment.enquiry.enrollmentCode' },
        { text: 'Class & Section', sortable: true, value: 'cls' },
        { text: 'Fee Plan', sortable: true, value: 'assignFeeInstallment.assignFeeComponent.name' },
        { text: 'Concession Amount', sortable: true, value: 'concessionAmount' },
        { text: 'Franchisee', sortable: true, value: 'assignFeeInstallment.franchisee.companyName' },
        // { text: 'Academic Year', sortable: true, value: 'assignFeeInstallment.franchiseeAcademicYear.academicYear' },
        { text: 'Created At', sortable: true, value: 'updatedAt' },
        { text: 'Status', sortable: true, value: 'status' },
        { text: 'Action', value: 'actions' }
      ]
    }
  },
  async created () {
    if (this.franchiseeID) {
      this.getConcessionList()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
    if (this.academicYear.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    async approveRequest (approvalStatus) {
      try {
        if (!this.concessionRequest.concessionRemark) {
          return this.errMsg('Concession remark is mandatory!')
        }
        this.concessionRequest.concessionAmount = parseFloat(this.concessionRequest.concessionAmount)
        if (!_.isNumber(this.concessionRequest.concessionAmount)) {
          return this.errMsg('Concession amount should be a number!')
        }
        const { data } = await http.post(`${CONSTANTS.API_URL}/api/installment/fee-concession/change-status/${this.concessionRequest.id}`, {
          concessionAmount: this.concessionRequest.concessionAmount,
          concessionRemark: this.concessionRequest.concessionRemark,
          dueDate: this.concessionRequest.dueDate,
          approvalStatus: approvalStatus
        })
        this.reviewModal = false
        this.okMsg(data)
        this.getConcessionList()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e
        this.errMsg(errorMessage)
      }
    },
    searchData () {
      if (this.search.length >= 3 || this.search.length === 0) {
        this.page = this.page > 1 ? this.page - 1 : this.page
        this.getConcessionList()
      }
    },
    async getConcessionList () {
      try {
        let payload = {
          franchiseeID: this.franchiseeID,
          academicYearID: this.academicYearID,
          page: this.page - 1,
          pageSize: this.pageSize,
          approvalStatus: this.selectedType,
          search: this.search,
          classId: this.selectedClass
        }
        const { data } = await http.post(`${CONSTANTS.API_URL}/api/installment/fee-concession/get-concession-requests`, payload)
        this.totalPages = data.totalPages
        this.tblData = []
        this.tblData = _.map(data.rows, (a) => {
          let classAndSection = _.orderBy(a.assignFeeInstallment.enquiry.studentEnrollment.studentAdmissions, ['academicYearID'], ['desc'])

          if (classAndSection.length > 0) {
            a.cls = `${classAndSection[0].class} - ${classAndSection[0].section}`
          } else {
            a.cls = '-'
          }
          a.updatedAt = moment(a.updatedAt).format('YYYY-MM-DD')
          return a
        })
        console.log(data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e
        this.errMsg(errorMessage)
      }
    },
    async getClassList () {
      try {
        this.selectedClass = ''
        if (this.franchiseeID && this.academicYearID) {
          const { data } = await http.get(`${CONSTANTS.API_URL}/api/student/all-count`, {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYearID,
              isAllValue: true
            }
          })
          this.classList = data
          this.classList.unshift({ id: '', name: 'All' })
        } else {
          this.classList = []
          this.classList.push({ id: '', name: 'All' })
        }
      } catch (e) {
        console.log(e)
      }
    },
    viewRequest (concessionReq) {
      this.reviewModal = true
      this.concessionRequest = {
        id: concessionReq.id,
        name: concessionReq.assignFeeInstallment.name,
        concessionRemark: concessionReq.concessionRemark,
        concessionAmount: concessionReq.concessionAmount,
        dueDate: moment(concessionReq.dueDate).format('YYYY-MM-DD')
      }
      console.log(this.concessionRequest)
    },
    onFranchiseeChange: async function () {
      this.searchFilterArray = []
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
          this.getClassList()
        } else {
          this.franchiseeID = ''
          this.getClassList()
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
          this.getClassList()
        } else {
          this.academicYearID = ''
          this.getClassList()
        }
        this.inProgress = false
      }
      await this.getConcessionList()
    },
    handlePageChange (value) {
      this.page = value
      this.getConcessionList()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getConcessionList()
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.toast.open({
        message: msg,
        type: 'is-danger',
        duration: 5000
      })
    }
  }
}
</script>
<style scoped>
.text-note {
  color: #dc3545;
  font-weight: 600;
}

.pb-0 {
  padding-bottom: 0;
}

.number-input >>> input[type='number'] {
  -moz-appearance: textfield;
}
.number-input >>> input::-webkit-outer-spin-button,
.number-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
